import React from "react"

import { Flex, Typography } from "antd"

import Icon from "../../../../../Icon"

import styles from "../CreditRequestInstructions.module.less"

const { Text } = Typography

export const Notice = ({ title, description }) => {
  return (
    <Flex gap="8px" className={styles.notice} align="flex-start">
      <Icon type="circle_info_strong" className={styles.icon} />
      <Flex vertical gap="4px">
        <Text strong>{title}</Text>
        <Text className={styles.noticeDescription}>{description}</Text>
      </Flex>
    </Flex>
  )
}
